import styled from 'styled-components';

// React-shared.
import SharedPageHeader from '@exonet/react-shared/lib/Elements/PageHeader';

export const PageHeader = styled(SharedPageHeader)`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--xs-padding-vertical);

  h1 {
    margin: 0;
  }
`;
